<template>
    <div>
      <el-dialog title="Трак код шалгуулах"  :visible.sync="this.$root.checkTrackCode"  width="90%" :before-close="handleClose" center>
        <el-form :model="trackCodeForm" :rules="rules" ref="trackCodeForm">
          <div class="check-info">
            <p>
              Та Тэнгэр карго Эрээн агуулахын хаяг дээр захиалсан, дараах шалгуурыг &nbsp;&nbsp;&nbsp;&nbsp; хангасан ачааг шалгуулах боломжтой. Үүнд:
            </p>
            <ul>
              <li>
                Бараа захиалтын аппликэйшн дээр Эрээнд очсон ч
                <a href="https://www.skycargo.mn" target="_blank">www.skycargo.mn</a>
                системд 3 хоногийн дотор Эрээн агуулах хүлээн авсан төлөвт ороогүй
                (Бараа захиалгын апп дээр Эрээнд очсон ачааг цуглуулах цэгээс татан авч, Эрээн агуулахад бүртгэлд оруулан Монгол руу ачуулж хүртэл хамгийн дээд хугацаа 3 хоног боломжтой)
              </li>
              <li>
                Эрээн агуулахад хүлээн авсан төлөвт орсоноос хойш экспресс тээврийн хувьд 5 хоног, энгийн тээврийн хувьд 14 хоногийн дотор Монгол дах салбарт бүртгэгдээгүй
                (Таны ачаа Эрээн агуулахаас Монгол руу тээвэрлэх хугацаа нь ачаа тээвэр хэвийн ачаалалтай үед экспресс тээвэр 2-3 хоног, энгийн тээвэр 4-10 хоног байна)
              </li>
            </ul>
          </div>
          <el-form-item label="Трак код" prop="track_code">
              <el-input v-model="trackCodeForm.track_code" disabled></el-input>
          </el-form-item>
          <el-form-item label="Утасны дугаар" prop="phone_number">
              <el-input v-model="trackCodeForm.phone_number" disabled></el-input>
          </el-form-item>
          <el-form-item label="Ачааны Эрээнд очсон огноо оруулна уу" prop="phone_number">
              <el-date-picker type="date" v-model="at_ereen_ognoo" placeholder="Огноо оруулна уу" :onClick="dateCheck() && dateCheckExpress()"></el-date-picker>
          </el-form-item>
          <div v-if="at_ereen_ognoo && dateCheck() === true">
            <el-form-item label="Бараа захиалсан салбар" prop="branch_id">
              <el-select v-model="trackCodeForm.branch_id" placeholder="Салбар сонгоно уу" class="w-100" @change="selectBranch(item)">
                <el-option v-for="(item,index) in branches" :key="index" :value="item.id" :label="item.branch_name"></el-option>
              </el-select>
            </el-form-item>
            <div v-if="progress_code === 110 && dateCheckExpress() === true && (trackCodeForm.branch_id === 6 || trackCodeForm.branch_id === 7)">
              <p class="no-wrap-text">
                Таны ачааг Эрээн агуулахаас Монгол руу тээвэрлэх хугацаа нь ачаа тээвэр хэвийн ачаалалтай үед экспресс тээвэр 2-3 хоног байх тул Эрээн агуулах хүлээн авсан төлөвт орсноос хойш 5 хоногийн дараа хүсэлтээ явуулна уу.
              </p>
            </div>
            <div v-else-if="progress_code === 110 && dateCheckEngiin() === true && (trackCodeForm.branch_id === 1 || trackCodeForm.branch_id === 2)">
              <p class="no-wrap-text">
                Таны ачааг Эрээн агуулахаас Монгол руу тээвэрлэх хугацаа нь ачаа тээвэр хэвийн ачаалалтай үед энгийн тээвэр 4-10 хоног байх тул Эрээн агуулах хүлээн авсан төлөвт орсноос хойш 14 хоногийн дараа хүсэлтээ явуулна уу.
              </p>
            </div>
            <div v-else>
              <el-row v-if="trackCodeForm.img_path.length">
                <el-col :span="6" v-for="(img, index) in trackCodeForm.img_path" :key="index">
                  <img :src="'https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com' + img" style="width: 100%; border-radius: 8px; margin-bottom: 10px; border: 1px solid black;" />
                </el-col>
              </el-row>
              <el-form-item label="Зураг оруулах" prop="img_path" class="text_unahgui"><br>
                <p class="check_tarck_img_text m-b-10">Ачааны трак кодтой, хүргэлтийн төлөв бүхий &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; газрын зурагтай хэсэг болон тухайн ачаа хүргэгдэх Эрээн дэх агуулахын хаягтай хэсгийг screen shot &nbsp;&nbsp;&nbsp;&nbsp; хийж оруулна уу. Эдгээр зургийг заавал зөв &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; оруулах шаардлагатай.</p>
                <el-button class="w-100"><DynamicUploadImage @uploaded="handleImageUploaded"></DynamicUploadImage></el-button>
              </el-form-item>
              <!-- <el-form-item label="Хүргэлтээр авах хаяг сонгоно уу" v-if="addressList.length">
                  <el-select  class="w-100" placeholder="Сонгоно уу">
                      <el-option v-for="item, index in addressList" :key="index" :value="item.id" :label="item.detail_address"></el-option>
                  </el-select>
              </el-form-item> -->
              <el-form-item label="Газрын зураг дээр эрээнд очсон эсэх" prop="ereend_ochson_eseh">
                  <el-checkbox-button size="mini" @change="doneEreen()" v-model="trackCodeForm.ereend_ochson_eseh">Эрээнд очсон</el-checkbox-button>
                  <el-checkbox-button size="mini" @change="dontEreen()" v-model="trackCodeForm.ereend_ochson_eseh_no">Эрээнд очоогүй</el-checkbox-button>
              </el-form-item>
              <el-form-item v-if="trackCodeForm.ereend_ochson_eseh === true" label="Эрээнд очсон огноо" prop="map_to_ereen_date">
                  <el-date-picker type="date" v-model="trackCodeForm.map_to_ereen_date" placeholder="Огноо оруулна уу"></el-date-picker>
              </el-form-item>
              <el-form-item label="Тайлбар" prop="description">
                  <el-input v-model="trackCodeForm.description" type="textarea" placeholder="Тайлбар оруулна уу"></el-input>
              </el-form-item>
              <el-form-item label="Facebook нэр" prop="fb_name">
                  <el-input v-model="trackCodeForm.fb_name" placeholder="Facebook нэрээ оруулна уу"></el-input>
              </el-form-item>
              <el-form-item v-if="trackCodeForm.ereend_ochson_eseh === true">
                <el-button class="button_background_color track_code_button" @click="handleSubmit()">Хадгалах</el-button><br>
              </el-form-item>
            </div>
          </div>
          <div>
            <el-row>
              <el-col v-if="at_ereen_ognoo && dateCheck() === false" class="m-b-10 no-wrap">
                <p class="no-wrap-text">
                  Бараа захиалгын апп дээр Эрээнд очсон ачааг цуглуулах цэгээс татан авч, Эрээн агуулахад бүртгэлд оруулан Монгол руу ачуулах хүртэл хамгийн дээд хугацаа 3 хонох боломжтой тул та энэ хугацаанаас хойш хүсэлтээ явуулна уу.
                </p>
              </el-col>
              <el-col v-if="at_ereen_ognoo && dateCheck() === false" class="m-t-10">
                <el-button type="success" size="mini" class="w-100" @click="handleClose()">Ойлголоо</el-button>
              </el-col>
              <el-col v-if="progress_code === 110 && dateCheckExpress() === true && (trackCodeForm.branch_id === 6 || trackCodeForm.branch_id === 7)" class="m-t-10">
                <el-button type="success" size="mini" class="w-100" @click="handleClose()">Ойлголоо</el-button>
              </el-col>
              <el-col v-if="progress_code === 110 && dateCheckEngiin() === true && (trackCodeForm.branch_id === 1 || trackCodeForm.branch_id === 2)" class="m-t-10">
                <el-button type="success" size="mini" class="w-100" @click="handleClose()">Ойлголоо</el-button>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </template>

<script>
import services from '@/helpers/services'
import { mapGetters, mapState } from 'vuex'
import DynamicUploadImage from '@/components/dynamicUploadImage.vue'

export default {
  name: 'checkTrackCode',
  props: {
    orderDetailProp: Object
  },
  computed: {
    ...mapGetters([
      'userDetailGetter'
    ]),
    ...mapState({
      dynamic_img_url: state => state.dynamic_img_url
    })
  },
  components: {
    DynamicUploadImage
  },
  data () {
    return {
      trackCodeForm: {
        id: null,
        progress_track_code_id: null,
        track_code: null,
        phone_number: null,
        hurgelt: false,
        ochij_avah: false,
        ereend_ochson_eseh: null,
        ereend_ochson_eseh_no: false,
        img_path: [],
        description: null,
        map_to_ereen: null,
        type: 'new',
        map_to_ereen_date: null,
        fb_name: null,
        company_id: 1,
        branch_id: null
      },
      addressList: [],
      rules: {
        ereend_ochson_eseh: [{ required: true, message: 'Сонгоно уу', trigger: 'blur' }],
        img_path: [{ required: true, message: 'Зураг оруулна уу', trigger: 'blur' }],
        map_to_ereen: [{ required: true, message: 'Сонгоно уу', trigger: 'blur' }],
        fb_name: [{ required: true, message: 'Facebook нэрээ оруулна уу', trigger: 'blur' }],
        description: [{ required: true, message: 'Тайлбар оруулна уу', trigger: 'blur' }],
        branch_id: [{ required: true, message: 'Бараа захиалсан салбар сонгоно уу', trigger: 'blur' }]
      },
      at_ereen_ognoo: null,
      branches: [],
      progress_code: null,
      progress_created_date: null
    }
  },
  created () {
    this.initData()
    this.getBranch()
  },
  watch: {
    dynamic_img_url () {
      this.trackCodeForm.img_path = this.dynamic_img_url
    }
  },
  methods: {
    handleImageUploaded (imageUrl) {
      if (!Array.isArray(this.trackCodeForm.img_path)) {
        this.trackCodeForm.img_path = []
      }
      this.trackCodeForm.img_path.push(imageUrl)
    },
    initData () {
      this.trackCodeForm.progress_track_code_id = this.orderDetailProp.progress_track_code_id
      this.trackCodeForm.track_code = this.orderDetailProp.track_code
      this.trackCodeForm.phone_number = this.orderDetailProp.phone_number
      this.progress_code = this.orderDetailProp.progress_code || null
      this.progress_created_date = this.orderDetailProp.progress_created_date || null
    },
    handleClose () {
      this.$root.checkTrackCode = false
    },
    hvrgeltCheck () {
      this.trackCodeForm.ochij_avah = false
      this.trackCodeForm.hurgelt = true
    },
    ochijAvahCheck () {
      this.trackCodeForm.ochij_avah = true
      this.trackCodeForm.hurgelt = false
    },
    doneEreen () {
      this.trackCodeForm.ereend_ochson_eseh = true
      this.trackCodeForm.ereend_ochson_eseh_no = false
    },
    dontEreen () {
      this.trackCodeForm.ereend_ochson_eseh = false
      this.trackCodeForm.ereend_ochson_eseh_no = true
    },
    handleSubmit () {
      try {
        if (this.trackCodeForm.map_to_ereen === true && this.trackCodeForm.map_to_ereen_date === null) {
          this.$notify({
            title: 'Анхааруулга',
            message: 'Эрээнд очсон огноо оруулна уу. ',
            type: 'warning',
            duration: 3000
          })
          return
        }
        this.$refs.trackCodeForm.validate((valid) => {
          if (valid) {
            this.$root.fullscreenLoading = true
            const payload = this.trackCodeForm
            const response = services.createCheckTrackCode(payload)
            if (response) {
              this.$root.fullscreenLoading = false
              this.$notify({
                title: 'Амжилттай',
                message: 'Амжилттай',
                type: 'success',
                duration: 3000
              })
              this.handleClose()
              this.$emit('reloadData')
            }
          } else {
            this.$root.fullscreenLoading = false
            this.$notify({
              title: 'Анхааруулга',
              message: 'Заавал бөглөх талбаруудыг бөглөнө үү.',
              type: 'warning',
              duration: 3000
            })
          }
        })
      } catch (error) {
        this.$root.fullscreenLoading = false
        alert(
          (this.$root.errorMessage =
                error.message || 'Өгөгдөл татхад алдаа гарлаа.')
        )
      }
    },
    dateCheck () {
      if (!this.at_ereen_ognoo) return false

      const today = new Date()
      const atEreenDate = new Date(this.at_ereen_ognoo)

      const differenceInMs = today - atEreenDate
      const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24))

      if (differenceInDays >= 3) {
        return true
      } else {
        return false
      }
    },
    getBranch () {
      services.getBranch()
        .then((response) => {
          this.branches = response.data
        })
        .catch((error) => {
          console.error('Алдаа:', error.message)
        })
    },
    dateCheckExpress () {
      if (this.progress_code === 100) return false

      const today = new Date()
      const atEreenDate = new Date(this.progress_created_date)

      const differenceInMs = today - atEreenDate
      const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24))

      if (differenceInDays >= 5) {
        return true
      } else {
        return false
      }
    },
    dateCheckEngiin () {
      if (this.progress_code === 100) return false

      const today = new Date()
      const atEreenDate = new Date(this.progress_created_date)

      const differenceInMs = today - atEreenDate
      const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24))

      if (differenceInDays >= 14) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style>
  .map_text {
    color: red;
    line-height: 17px;
  }
  .el-select-dropdown__item {
    white-space: normal !important;
    word-break: break-word;
    max-width: 300px; /* эсвэл 100% */
  }
  .check-info {
    p {
      font-size: 16px;
      margin-bottom: 12px;
      line-height: 1.6;
    }

  ul {
    padding-left: 20px;
    list-style-type: disc;

    li {
      margin-bottom: 10px;
      line-height: 1.6;
      word-break: normal;
      white-space: normal;
      text-indent: 0;
    }

    a {
      color: #2a76d2;
      text-decoration: underline;
    }
  }
  .text_unahgui {
    margin-bottom: 10px;
      line-height: 1.6;
      word-break: normal;
      white-space: normal;
      text-indent: 0;
  }
}
</style>
